import React from 'react';

import Pagination from '@material-ui/lab/Pagination';

import styles from './ArticlePagination.module.scss';

export interface ArticlePaginationProps {
  pageCount: number;
  page: number;
  onChange: (page: number) => void;
}

const ArticlePagination: React.FC<ArticlePaginationProps> = ({ pageCount, page, onChange }) => {
  if (pageCount <= 1) {
    return null;
  }

  return (
    <div className={styles.pagination}>
      <Pagination
        count={pageCount}
        page={page}
        variant="outlined"
        shape="rounded"
        color="primary"
        onChange={(_e, value) => onChange(value)}
      />
    </div>
  );
};

export default ArticlePagination;
